import { css } from '@/styled-system/css';

export const toastCloseStyles = css.raw({
  marginBlock: `calc(-1 * {spacing.Toast.padding.vert})`,
  marginInlineEnd: `calc(-1 * {spacing.Toast.padding.horz})`,
  marginInlineStart: 'Toast.gap.trailing',
  paddingBlockStart: 'Toast.CloseButton.margin.top',
  paddingInlineEnd: 'Toast.CloseButton.margin.right',
});
